/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {REGEX} from '../../constants'
import {useToast} from '../../hooks/use-toast'
import {useXSSProtection} from './../../hooks/use-xss-protection'

export default function useLoginFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const toast = useToast()
    const {formatMessage} = useIntl()
    const {validateField} = useXSSProtection()

    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email Address',
                id: 'use_login_fields.label.email'
            }),
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_login_fields.error.required_email'
                }),
                pattern: {
                    value: REGEX.EMAIL,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid email address.',
                        id: 'use_login_fields.error.invalid_email'
                    })
                },
                validate: (value) => validateField(toast, value, 'login-form', 'email')
            },
            error: errors?.[`${prefix}email`],
            control
        },
        password: {
            name: `${prefix}password`,
            label: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            defaultValue: '',
            type: 'password',
            autoComplete: 'current-password',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your password.',
                    id: 'use_login_fields.error.required_password'
                }),
                validate: (value) => validateField(toast, value, 'login-form', 'password')
            },
            error: errors?.[`${prefix}password`],
            control
        }
    }
    return fields
}
